import { useMemo } from 'react';
import { StateCallbacks } from '#reviewCheck/objects';
import { useMenuActionsBlocker } from '#baseMenu/hooks';

const useStateCallbacks = () => {
  const menuActionsBlocker = useMenuActionsBlocker();

  return useMemo(() => new StateCallbacks({
    onOpen: () => {
      menuActionsBlocker.blockActions();
    },
    onOpened: () => {
      menuActionsBlocker.unblockActions();
    },
    onHide: () => {
      menuActionsBlocker.blockActions();
    },
    onHidden: () => {
      menuActionsBlocker.unblockActions();
    },
  }), [menuActionsBlocker]);
};

export { useStateCallbacks };
